import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';

@Component({
    selector: 'app-product-overview-main-kpi',
    templateUrl: './products-overview-kpi.component.html',
    styleUrls: ['./products-overview-kpi.component.css']
})
//Pagina 35
export class ProductsOverviewKpiComponent implements OnInit {
    show_results = false;

    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    public indicators: IndicatorBoxModel[] = [];
    public translations: any;
    public storeError = false;
    public selectOneError: string;
    public data: QFilterModel;

    constructor(
        private indicatorService: IndicatorsService,
        private chartsService: IndicatorsChartService,
        private svcAnalytics: AnalyticsService,
        private srvCustomerCampaign: CustomerCampaignService,
        private translate: TranslateService,
        private searchModelFactory: SearchToolbarModelFactoryService,
    ) {
    }

    ngOnInit() {

        this.translate.get([
            'kpiChart.segmentDistribution',
            'kpiChart.selectedShop',
            'kpiChart.formatAverage',
            'kpiChart.axisTitle'
        ]).subscribe((t) => {
            this.translations = {
                segmentDistribution: t['kpiChart.segmentDistribution'],
                selectedShop: t['kpiChart.selectedShop'],
                formatAverage: t['kpiChart.formatAverage'],
                axisTitle: t['kpiChart.axisTitle']
            };
        });

        this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
    }

    searchValue(data: QFilterModel) {
        this.data = data;

        this.translate.get([
            'indicator.fatturato',
            'indicator.transazioni',
            'indicator.volume',
            'indicator.sconto_medio',
            'indicator.importo_medio_scontrino',
            'indicator.importo_medio_prodotto',
            'indicator.volume_medio_scontrino',
            'indicator.numero_battute_medio'
        ]).subscribe(t => {
            this.indicators = [];

            Observable.zip(

                this.indicatorService.indicatorCalculation('products.Q168', this.data)

            ).subscribe(
                ([Q168]) => {

                    /*168*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'fatturato')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                    /*169*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'transazioni')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));
                    /*170*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'volume')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));
                    /*171*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));
                    /*172*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'importo_medio_scontrino')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                    /*173*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'importo_medio_prodotto')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                    /*174*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'volume_medio_scontrino')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));
                    /*175*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'numero_battute_medio')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));

                });

        });
        this.show_results = true;

    }

    public toogleErrorStoreDialog() {
        this.storeError = !this.storeError;
    }

    resetData() {
        this.show_results = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/products/products-overview/products-overview-kpi/products-overview-kpi.component.ts